export const BUSINESS_NAME = process.env.NEXT_PUBLIC_SITE_NAME ?? 'default';
